module.exports = __webpack_public_path__ + "img/img9.24d6e6dd.svg";